/**
 * Google Analytics 4 (gtag.js) loader.
 *
 * Call `initGA4()` once at app startup. It injects the gtag.js script
 * and configures the measurement ID. The existing analytics service
 * already forwards events via `window.gtag()`.
 *
 * Set VITE_GA4_MEASUREMENT_ID in your environment to enable.
 * If not set, GA4 is silently skipped.
 */

export function initGA4(): void {
  const measurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID;
  if (!measurementId || typeof window === 'undefined') return;

  // Avoid double-init
  if (document.querySelector(`script[src*="googletagmanager.com/gtag"]`)) return;

  // gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  // gtag config
  const win = window as unknown as Record<string, unknown>;
  win.dataLayer = (win.dataLayer as unknown[]) || [];
  function gtag(...args: unknown[]) {
    (win.dataLayer as unknown[]).push(args);
  }
  win.gtag = gtag;
  gtag('js', new Date());
  gtag('config', measurementId, {
    send_page_view: true,
  });
}
